export const SITE = {
  url: "https://binhaideradvocates.com",
  name: "Bin Haider Advocates",
  ogImage: "https://binhaideradvocates.com/og-image.jpg",
  defaultTitle: "Bin Haider Advocates & Legal Consultants | Top Law Firm in Dubai, UAE",
  defaultDescription:
    "Bin Haider Advocates & Legal Consultants — trusted legal experts providing professional legal services in the UAE. Contact us today for expert legal advice.",
};

/** Meta title + description per route. */
export const PAGE_SEO = {
  home: {
    title: "Bin Haider Advocates & Legal Consultants | Top Law Firm in Dubai, UAE",
    description:
      "Bin Haider Advocates – Dubai's trusted law firm since 2002. Expert in Civil, Criminal, Corporate, Real Estate & IP Law across UAE & GCC. Book a consultation.",
  },
  aboutUs: {
    title: "About Bin Haider Advocates | Trusted Dubai Law Firm Since 2002",
    description:
      "Founded in 2002 by Isa Bin Haider. 200+ years of combined expertise in Civil, Criminal, Corporate, Real Estate & IP Law across UAE & GCC. Multilingual lawyers.",
  },
  ourTeam: {
    title: "Meet Our Lawyers | Bin Haider Advocates – Dubai Legal Experts",
    description:
      "Meet the expert lawyers at Bin Haider Advocates Dubai. 200+ years of combined experience in Corporate, Criminal, Real Estate & IP Law. Multilingual team – Arabic, English, Hindi & more.",
  },
  practiceArea: {
    title: "Legal Services in Dubai | Bin Haider Advocates – All Practice Areas",
    description:
      "Expert legal services in Dubai across Corporate, Civil, Criminal, Real Estate, IP, Labour, Insurance, Maritime & International Law. Bin Haider Advocates – trusted UAE & GCC counsel since 2002.",
  },
  blog: {
    title: "Legal Blog | Bin Haider Advocates & Legal Consultants Dubai",
    description:
      "Stay updated with expert legal insights, UAE law updates, and practical legal guides from Bin Haider Advocates – Dubai's trusted law firm since 2002. Corporate, Real Estate, Criminal & more.",
  },
  contactUs: {
    title: "Contact Us | Bin Haider Advocates & Legal Consultants",
    description:
      "Contact Bin Haider Advocates & Legal Consultants in Dubai. Call +971 4 421 3914 or visit our offices in Dubai, Sharjah & Fujairah. Book a free legal consultation today.",
  },
  privacyPolicy: {
    title: "Privacy Policy | Bin Haider Advocates & Legal Consultants",
    description:
      "How Bin Haider Advocates & Legal Consultants collects, uses and protects the personal information you share with us.",
  },
};

/**
 * Hand-written meta for named team members. `/our-team-view` is driven by a
 * `team_id` query param, so the member name coming back from the API is matched
 * against these keys (lowercased, punctuation-insensitive) and anything without
 * an entry falls back to buildMemberSeo() below.
 */
const MEMBER_SEO = [
  {
    match: "abdullah mohammed saeed banama",
    title: "Mr. Abdullah Mohammed Saeed Banama | Advocate & Legal Consultant",
    description:
      "Meet Mr. Abdullah Mohammed Saeed Banama, an experienced advocate and legal consultant at Bin Haider Advocates & Legal Consultants in the UAE.",
  },
  {
    match: "salem saeed ahmad saeed bin kowair",
    title: "Mr. Salem Saeed Ahmad Saeed Bin Kowair | Advocate",
    description:
      "Meet Mr. Salem Saeed Ahmad Saeed Bin Kowair, a qualified advocate and legal consultant at Bin Haider Advocates & Legal Consultants, Dubai.",
  },
  {
    match: "muna mohammed moosa al mandoos alblooshi",
    title: "Ms. Muna Mohammed Moosa Al Mandoos Alblooshi | Advocate",
    description:
      "Meet Ms. Muna Mohammed Moosa Al Mandoos Alblooshi, a dedicated advocate and legal consultant at Bin Haider Advocates & Legal Consultants, Dubai.",
  },
  {
    match: "ahmed abdelazim abdelgadr esmael",
    title: "Ahmed Esmael | Legal Consultant",
    description:
      "Meet Mr. Ahmed Abdelazim Abdelgadr Esmael, a skilled legal consultant at Bin Haider Advocates & Legal Consultants in Dubai.",
  },
  {
    match: "mohamed eltahir mohamed dafalla",
    title: "Mohamed Dafalla | Legal Consultant",
    description:
      "Meet Mr. Mohamed Eltahir Mohamed Dafalla, a qualified legal consultant at Bin Haider Advocates & Legal Consultants, Dubai. Providing professional legal services in litigation, civil, commercial, and corporate law across the UAE.",
  },
  {
    match: "yasser mohamed elgendy",
    title: "Yasser Elgendy | Senior Legal Consultant",
    description:
      "Meet Mr. Yasser Mohamed Elgendy, Senior Legal Consultant at Bin Haider Advocates & Legal Consultants, Dubai.",
  },
  {
    match: "awad elkarim mohamed ali",
    title: "Awad Elkarim Mohamed Ali | Bin Haider Advocates",
    description:
      "Meet Awad Elkarim Mohamed Ali at Bin Haider Advocates. Learn about his legal experience, professional background, and role within our legal team.",
  },
  {
    match: "alawi salem mohammed al sakkaf",
    title: "Alawi Salem Mohammed Al Sakkaf | Bin Haider Advocates",
    description:
      "Meet Alawi Salem Mohammed Al Sakkaf at Bin Haider Advocates. Learn about his professional background and role within our experienced legal team.",
  },
  {
    match: "aref yahya hussein al sharafi",
    title: "Aref Yahya Hussein Al Sharafi | Bin Haider Advocates",
    description:
      "Meet Aref Yahya Hussein Al Sharafi at Bin Haider Advocates. Discover his professional background and role within our experienced legal team.",
  },
  {
    match: "el fathih ahmed abdel rahman bagouri",
    title: "El Fathih Ahmed Abdel Rahman Bagouri | Bin Haider Advocates",
    description:
      "Meet El Fathih Ahmed Abdel Rahman Bagouri at Bin Haider Advocates. Learn about his professional background and role within our legal team.",
  },
  {
    match: "aliah alzahrani",
    title: "Aliah Alzahrani | Legal Team | Bin Haider Advocates",
    description:
      "Meet Aliah Alzahrani, a member of the Bin Haider Advocates legal team. Learn about her professional background and role at the firm.",
  },
  {
    match: "ali amr",
    title: "Ali Amr | Legal Team | Bin Haider Advocates",
    description:
      "Meet Ali Amr at Bin Haider Advocates. Learn about his professional background, experience, and role within our legal team.",
  },
  {
    match: "mohannad salah ali mohammed",
    title: "Mohannad Salah Ali Mohammed | Bin Haider Advocates",
    description:
      "Meet Mohannad Salah Ali Mohammed at Bin Haider Advocates. Learn about his professional background and role within our experienced legal team.",
  },
];

const normalise = (value) =>
  String(value || "")
    .toLowerCase()
    // Anchored and word-bounded: an unanchored global strip ate the "dr " out
    // of names like "Abdelgadr Esmael".
    .replace(/^(mr|mrs|ms|dr|adv|advocate)\.?\s+/, "")
    .replace(/[^a-z\s]/g, " ")
    .replace(/\s+/g, " ")
    .trim();

/** Meta for one team member, preferring the hand-written entry when there is one. */
export const buildMemberSeo = (member, language_web = "en") => {
  const name = member?.[language_web]?.name || member?.en?.name;
  if (!name) return PAGE_SEO.ourTeam;

  const key = normalise(name);
  const preset = MEMBER_SEO.find((m) => key === m.match || key.includes(m.match) || m.match.includes(key));
  if (preset) return preset;

  const position = member?.[language_web]?.position || member?.en?.position || "Legal Team";
  return {
    title: `${name} | ${position} | Bin Haider Advocates`,
    description: `Meet ${name}, ${position} at Bin Haider Advocates & Legal Consultants, Dubai. Learn about their professional background and role within our legal team.`,
  };
};

/** Image alt text for the static/decorative imagery called out in the SEO brief. */
export const IMAGE_ALT = {
  logo: "Bin Haider Advocates & Legal Consultants",
  founder: "CEO & Founder Mr. ISA BIN HAIDER",
  practiceAreas:
    "Criminal law, civil law, commercial law, maritime law, personal status, Commercial and Civil Arbitration",
  aboutUs: "About Bin Haider Advocates & Legal Consultants",
};

/** schema.org LegalService description of the firm, emitted on the home page. */
export const ORGANIZATION_JSONLD = {
  "@context": "https://schema.org",
  "@type": "LegalService",
  name: "Bin Haider Advocates & Legal Consultants",
  url: SITE.url,
  image: SITE.ogImage,
  logo: `${SITE.url}/binhaiderf.svg`,
  description: PAGE_SEO.home.description,
  foundingDate: "2002",
  founder: { "@type": "Person", name: "Isa Bin Haider" },
  email: "info@bhadvoc.com",
  telephone: "+971 4 421 3914",
  areaServed: ["AE", "United Arab Emirates", "GCC"],
  address: {
    "@type": "PostalAddress",
    streetAddress: "1801 & 1802, The H Hotel Office Tower, One Sheikh Zayed Road",
    postOfficeBoxNumber: "98444",
    addressLocality: "Dubai",
    addressCountry: "AE",
  },
  knowsLanguage: ["ar", "en"],
  availableLanguage: ["Arabic", "English"],
  knowsAbout: [
    "Civil Law",
    "Criminal Law",
    "Corporate Law",
    "Real Estate Law",
    "Intellectual Property Law",
    "Labour Law",
    "Insurance Law",
    "Maritime Law",
    "International Law",
    "Commercial and Civil Arbitration",
  ],
};

/**
 * Positions that get a "View Profile" card on /our-team.
 *
 * ClientOurTeam.jsx renders Legal Researchers with <ImageCardWithoutModal>, so
 * those members have no profile link anywhere on the site. Their detail pages
 * still render if you have the URL, but they are kept out of the sitemap and
 * marked noindex — a sitemap should not advertise a page nothing links to.
 */
export const PROFILE_LINKED_POSITIONS = ["Lawyer", "Consultant", "Client Relations"];

export const hasPublicProfile = (member) =>
  PROFILE_LINKED_POSITIONS.includes(member?.en?.position);
